import { useSceneStore } from '../../stores/sceneStore';
import { getSpineManager } from '../../lib/spine-manager';
import type { Layer } from '@spine-workspace/shared';

interface SkinSelectorProps {
  layer: Layer;
  skins: string[];
}

export default function SkinSelector({ layer, skins }: SkinSelectorProps) {
  const setLayerSkin = useSceneStore((s) => s.setLayerSkin);

  function handleSkin(skin: string) {
    setLayerSkin(layer.id, skin);
    getSpineManager().setSkin(layer.id, skin);
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {skins.map((skin) => (
        <button
          key={skin}
          onClick={() => handleSkin(skin)}
          className={`px-3 py-1 rounded-full font-sans text-xs font-medium border transition-all duration-normal ${
            layer.skin === skin
              ? 'bg-accent-muted border-accent/30 text-accent'
              : 'bg-bg-input border-border text-text-secondary hover:border-accent hover:text-text-primary'
          }`}
        >
          {skin}
        </button>
      ))}
    </div>
  );
}
